import React, { useState, useEffect } from "react";
import { Box, Grid, Paper, Typography, Alert } from "@mui/material";
import PaymentProfileTable from "./PaymentProfileTable";
import PaymentDetailModal from "./PaymentDetailModal";
import { getToken } from "services/auth.service";

const PaymentManagement = ({ contractId, contractData }) => {
  const [selectedPaymentProfile, setSelectedPaymentProfile] = useState(null);
  const [showPaymentDetailModal, setShowPaymentDetailModal] = useState(false);
  const [contractItems, setContractItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0); // Thêm refresh key

  useEffect(() => {
    if (contractId) {
      loadContractItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractId]);

  const loadContractItems = async () => {
    setLoading(true);
    try {
      const token = getToken();

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/contract-items/by-contract/${contractId}/hierarchical`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const result = await response.json();
    

        // Debug: In ra cấu trúc dữ liệu để kiểm tra
        if (result.data && result.data.length > 0) {
        
        }

        setContractItems(result.data || []);
      } else {
        console.error(
          "API response not ok:",
          response.status,
          response.statusText
        );
        throw new Error("Failed to load contract items");
      }
    } catch (error) {
      console.error("Error loading contract items:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePaymentProfileSelect = (profile) => {
    setSelectedPaymentProfile(profile);
    setShowPaymentDetailModal(true);
  };

  const handleClosePaymentDetailModal = () => {
    setShowPaymentDetailModal(false);
    setSelectedPaymentProfile(null);
  };

  const handleRefresh = () => {
    loadContractItems();
    setRefreshKey((prev) => prev + 1); // Trigger refresh cho PaymentProfileTable
  };

  if (!contractId || !contractData) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Alert severity="info">
          Vui lòng chọn một hợp đồng để quản lý thanh toán
        </Alert>
      </Box>
    );
  }

  if (contractItems.length === 0 && !loading) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontFamily: "Inter, sans-serif", fontWeight: 600 }}
        >
          Quản lý thanh toán hợp đồng
        </Typography>
        <Alert severity="warning">
          Hợp đồng này chưa có hạng mục. Vui lòng thêm hạng mục trước khi tạo kỳ
          thanh toán.
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontFamily: "Inter, sans-serif",
          fontWeight: 600,
          color: "#333",
          mb: 1,
        }}
      >
        Quản lý thanh toán hợp đồng
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        gutterBottom
        sx={{ mb: 3 }}
      >
        {contractData.contractNumber} - {contractData.contractName}
      </Typography>

      <Grid container spacing={3}>
        {/* Payment Profiles Section - giờ chiếm toàn bộ width */}
        <Grid item xs={12}>
          <Paper
            sx={{
              p: 3,
              border: "1px solid #e0e0e0",
              boxShadow: "none",
              borderRadius: 2,
            }}
          >
            <PaymentProfileTable
              contractId={contractId}
              contractNumber={contractData.contractNumber}
              contractName={contractData.contractName}
              contractItems={contractItems}
              contractData={contractData}
              onPaymentProfileSelect={handlePaymentProfileSelect}
              refreshKey={refreshKey} // Truyền refreshKey để trigger re-fetch data
            />
          </Paper>
        </Grid>
      </Grid>

      {/* Payment Detail Modal - thay thế cho ContractPaymentTable ở dưới */}
      <PaymentDetailModal
        open={showPaymentDetailModal}
        onClose={handleClosePaymentDetailModal}
        paymentProfile={selectedPaymentProfile}
        contractItems={contractItems}
        onRefresh={handleRefresh}
      />

      {/* Instructions - cập nhật hướng dẫn */}
      {!showPaymentDetailModal && (
        <Box sx={{ mt: 3 }}>
          <Alert severity="info" sx={{ fontFamily: "Inter, sans-serif" }}>
            <Typography variant="body2">
              <strong>Hướng dẫn sử dụng:</strong>
            </Typography>
            <Typography variant="body2" component="div" sx={{ mt: 1 }}>
              1. Tạo các kỳ thanh toán cho hợp đồng (VD: Tạm ứng, Thanh toán lần
              1, Nghiệm thu...)
              <br />
              2. <strong>Click chọn một kỳ thanh toán</strong> để mở cửa sổ chi
              tiết và thêm thanh toán theo hạng mục
              <br />
              3. Hệ thống sẽ tự động tính toán thành tiền bao gồm VAT theo từng
              kỳ
            </Typography>
          </Alert>
        </Box>
      )}
    </Box>
  );
};

export default PaymentManagement;
